import React, { ReactNode } from 'react';
import { useNavigate } from 'react-router-dom';
import { SimpleResumeManagerStore } from './simple-resume-manager.store';

const SimpleResumeManagerContext = React.createContext<SimpleResumeManagerStore | null>(null);

export const SimpleResumeManagerProvider = ({ children }: { children: ReactNode }) => {
   const navigate = useNavigate();
   const [store] = React.useState<SimpleResumeManagerStore>(
      () => new SimpleResumeManagerStore(navigate)
   );

   return (
      <SimpleResumeManagerContext.Provider value={store}>
         {children}
      </SimpleResumeManagerContext.Provider>
   );
};

export const useSimpleResumeManager = () => {
   const ctx = React.useContext(SimpleResumeManagerContext);
   if (!ctx) {
      throw new Error('useSimpleResumeManager must be used inside SimpleResumeManagerProvider');
   }

   return ctx;
};
